import * as React from "react";
import { RootState } from "../../redux";
import { IChat } from "../../types/index";
import { connect, Dispatch } from "react-redux";
import * as moment from "moment";

import Message from "../../components/Message";

import { getMessages, acceptChatInvitation, refuseChatInvitation } from "../../redux/modules/appChats/appChats";

import API from "../../vendor/api";

import { IMessage } from "../../types/index";

import FormElements from "../../components/FormElements";

const Button = FormElements.Buttons.Primary;

const s = require("./messages.scss");

interface IMessagesProps {
    currentChat?: IChat;
    auth: API.User;
    firstMessageOnCurrentChat?: IMessage;
    dispatch?: Dispatch<any>;
};

interface IMessagesState {};

class Messages extends React.Component<IMessagesProps, IMessagesState> {
    messageScroll: HTMLUListElement;
    shouldScrollBottom: boolean;
    canLoadMoreMessages: boolean = true;
    scrollHeight: number;
    scrollTop: number;

    loadMoreMessages() {
        if (!this.canLoadMoreMessages) {
            return;
        }

        this.canLoadMoreMessages = false;

        let currentChat = this.props.currentChat;
        let since = this.props.firstMessageOnCurrentChat.time;
        this.props.dispatch(getMessages(currentChat.id, since));
    }

    componentDidMount() {
        var node = this.messageScroll;
        node.scrollTop = node.scrollHeight;
        node.addEventListener('scroll', this.handleScroll.bind(this));
    }

    componentWillUnmount() {
        this.messageScroll.removeEventListener('scroll', this.handleScroll);
    }

    handleScroll(event: any) {
        const scrollTop = event.srcElement.scrollTop;
        // const scrollHeight = event.srcElement.scrollHeight;

        if (scrollTop < 50) {
            this.loadMoreMessages();
        }
    }

    componentWillUpdate() {
        var node = this.messageScroll;
        this.scrollHeight = node.scrollHeight;
        this.scrollTop = node.scrollTop;

        // this.shouldScrollBottom = node.scrollTop + node.offsetHeight === node.scrollHeight;
    }

    componentDidUpdate() {
         var node = this.messageScroll;

        // if (this.shouldScrollBottom) {
        //     node.scrollTop = node.scrollHeight;
        // }

        if (node.scrollHeight !== this.scrollHeight) {
            this.canLoadMoreMessages = true;
        }
        node.scrollTop = this.scrollTop + (node.scrollHeight - this.scrollHeight);

    }

    public render(): JSX.Element {
        let insertedDates: moment.Moment[] = [];
        let messages = this.props.currentChat.messages.map(message => {
            let currentMessageDate = moment(message.time);
            let metaDate = null;

            let exist = insertedDates.find(insertedDate => {
                if (insertedDate.isSame(currentMessageDate, "day")) {
                    return true;
                }
                return false;
            });

            if (message.type === API.MessageType.Text && !exist) {
                insertedDates.push(currentMessageDate);
                metaDate = (
                    <li key={"date-" + message.id} className={s.meta}>
                        <span>Dia {currentMessageDate.format("DD/MM/YYYY")}</span>
                    </li>
                );
            }

            let mine = (message.sender_id === this.props.auth.id);

            return (
                <div key={message.id}>
                    {metaDate}
                    <Message                        
                        message={message}
                        mine={mine}
                    />
                </div>
            );
        });

        return (
            <div className={s.messages}>
                <ul ref={(messageScroll) => { this.messageScroll = messageScroll; }} className={s.messagesList}>
                    {messages}
                </ul>

                {
                    !this.props.currentChat.is_member ?
                        <div className={s.invitationDialogWrapper}>
                            <div className={s.invitationDialog}>
                                <div className={s.content}>Você recebeu um convite para entrar nesse grupo. Deseja aceitar?</div>
                                <div className={s.invitationDialogButtons}>
                                    <Button
                                        onClick={() => this.props.dispatch(acceptChatInvitation(this.props.currentChat.id))}
                                    >
                                        Aceitar
                                    </Button>

                                    <Button
                                        onClick={() => this.props.dispatch(refuseChatInvitation(this.props.currentChat.id))}
                                    >
                                        Recusar
                                    </Button>
                                </div>
                            </div>
                        </div>
                    : null
                }
            </div>
        );
    }
}

export default connect((state: RootState) => {
    let obj: IMessagesProps = {
        auth: state.auth.user
    };

    const selectedChat = state.entities.chats.byId[state.ui.chats.selected];
    if (selectedChat) {
        obj.currentChat = Object.assign({}, selectedChat, {

            messages: selectedChat.messages.map(messageId => {
                return state.entities.messages.byId[messageId];
            })
        });
        obj.firstMessageOnCurrentChat = state.entities.messages.byId[selectedChat.firstMessageId];
    }

    return obj;
})(Messages);



// WEBPACK FOOTER //
// ./src/containers/Messages/index.tsx